import { ActiveRecord } from '../api/ActiveRecord';
import { handleError } from './error';

class CRUDActions {
  prefix = '';

  pageSize = 50;

  constructor() {
    let model = this._model;
    let instance = new model();
    if (!(instance instanceof ActiveRecord)) {
      throw new Error('Model has to be an ActiveRecord');
    }

    this._page = 1;
  }

  /**
   *
   * @private
   * @return ActiveRecord
   */
  get _model() {
    throw new Error('this component works only with active record');
  }

  get closeEditFormAction() {
    return this.prefix + '_close_edit_form';
  }

  get fetchListAction() {
    return this.prefix + '_list_fetch';
  }

  get fetchListFinishedSuccessAction() {
    return this.fetchListAction + '_done';
  }

  get fetchListFinishedFailAction() {
    return this.fetchListAction + '_fail';
  }

  get fetchListMoreAction() {
    return this.prefix + '_list_more_fetch';
  }

  get fetchListMoreFinishedSuccessAction() {
    return this.fetchListMoreAction + '_done';
  }

  get fetchListMoreFinishedFailAction() {
    return this.fetchListMoreAction + '_fail';
  }

  get fetchItemAction() {
    return this.prefix + '_fetch';
  }

  get fetchItemFinishedSuccessAction() {
    return this.fetchItemAction + '_done';
  }

  get fetchItemFinishedFailAction() {
    return this.fetchItemAction + '_fail';
  }

  get saveItemAction() {
    return this.prefix + '_save';
  }

  get saveItemFinishedSuccessAction() {
    return this.saveItemAction + '_done';
  }

  get saveItemFinishedFailAction() {
    return this.saveItemAction + '_fail';
  }

  get removeItemAction() {
    return this.prefix + '_remove';
  }

  get removeItemFinishedSuccessAction() {
    return this.removeItemAction + '_done';
  }

  get removeItemFinishedFailAction() {
    return this.removeItemAction + '_fail';
  }

  get createModelAction() {
    return this.prefix + '_create';
  }

  fetchList(query = {}) {
    
    this._page = 1;

    return async dispatch => {
      dispatch({ type: this.fetchListAction, query });

      try {
        let items = await this._model.listAction(
          query,
          this.pageSize,
          this._page - 1,
        );

        dispatch({
          type: this.fetchListFinishedSuccessAction,
          hasMore: items.length == this.pageSize,
          items
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return dispatch({
          type: this.fetchListFinishedFailAction,
          error
        });
      }
    };
  }

  fetchListMore(query = {}) {
    this._page++;
    return async dispatch => {
      dispatch({ type: this.fetchListMoreAction });
      try {
        let items = await this._model.listAction(
          query,
          this.pageSize,
          this._page - 1,
        );

        return dispatch({
          type: this.fetchListMoreFinishedSuccessAction,
          hasMore: items.length == this.pageSize,
          items
        });
      } catch (error) {
        return dispatch({
          type: this.fetchListMoreFinishedFailAction,
          error
        });
      }
    };
  }

  createModel() {
    return {
      type: this.createModelAction,
      model: new this._model()
    };
  }

  fetch(id) {
    let model = new this._model({ id });

    return async dispatch => {
      try {
        dispatch({ type: this.fetchItemAction })
        await model.fetch()
        dispatch({
          type: this.fetchItemFinishedSuccessAction,
          model
        })
      } catch (error) {
        handleError(error)(dispatch)
        dispatch({
          type: this.fetchItemFinishedFailAction,
          error: handleError(error)
        });
        throw error;
      }
    }
      
  }

  /**
   * save data to state. Using assign to object is bad practice.
   *
   * @param ActiveRecord model
   * @returns {Function}
   */
  save(model, data) {
    return async dispatch => {
      try {
        dispatch({
          type: this.saveItemAction
        });
        await model.save(data);

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model
        });

        return model;
      } catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });

        throw error;
      }
    };
  }

  remove(model) {
    return dispatch =>
      Promise.resolve(dispatch({ type: this.removeItemAction }))
        .then(() => model.remove())
        .then(
          () =>
            dispatch({
              type: this.removeItemFinishedSuccessAction,
              model
            }),
          res => {
            dispatch({
              type: this.removeItemFinishedFailAction,
              error: res
            });
            return Promise.reject(res.errors || {});
          },
        );
  }

  onCloseEditForm() {
    return {
      type: this.closeEditFormAction
    };
  }
}

export default CRUDActions;



// WEBPACK FOOTER //
// ./src/actions/CRUD.js